
import React from 'react';
import { withRouter } from 'react-router-dom';
import withAccountInputs from '../../containers/withAccountInputsV1';
import withPackages from '../../containers/withPackages';
import AccountInputsV2 from '.';
import useAccountInputs from '../../hooks/AccountInputs';

interface ConnectedAccountInputsV2Props {
  history: any;
  formInputs: any;
  createUser: any;
  packages: any;
}

const ConnectedAccountInputsV2: React.FC<ConnectedAccountInputsV2Props> = ({
  history,
  formInputs,
  createUser,
  packages
}) => {
  const {
    onToggleUseEmailAddress,
    onChangeEmail,
    onBlurEmail,
    onChangeUsername,
    onBlurUsername,
    onChangePassword,
    onBlurPassword,
    onPasswordError,
    accountInputsState
  } = useAccountInputs();

  return (
    <AccountInputsV2
      onToggleUseEmailAddress={onToggleUseEmailAddress}
      onChangeEmail={onChangeEmail}
      onBlurEmail={onBlurEmail}
      onChangeUsername={onChangeUsername}
      onBlurUsername={onBlurUsername}
      onChangePassword={onChangePassword}
      onBlurPassword={onBlurPassword}
      onPasswordError={onPasswordError}
      accountInputsState={accountInputsState}
      history={history}
      formInputs={formInputs}
      createUser={createUser}
      packages={packages}
    />
  );
};

export default withRouter(
  withAccountInputs(withPackages(ConnectedAccountInputsV2))
);